import React, { Component } from 'react';

export default class Refresh extends Component {

	constructor(props) {
    super(props);
		this.refresh = this.refresh.bind(this);
    this.state = {
			refresh: false
		};
  }

	render() {
		console.log('Refresh render', this.props);
		return (
			<button id="refresh" onClick={ this.refresh }>Check messages</button>
		);
	}
	
	refresh(e) {
		e.preventDefault();
		console.log('Refresh!');
		this.props.onRefresh(this.state);
		this.setState({ refresh: true});
	}
}



// WEBPACK FOOTER //
// ./src/components/refresh.jsx